import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

import { KeycloakService } from '../services/keycloak.service';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from '../services/loader.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
    constructor(
        private keycloakService: KeycloakService,
        private loader: LoaderService,
        private translateService: TranslateService,
    ) {}
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
        // this.loader.showLoader();
        let header = this.keycloakService.getHttpHeader();
        if (req.body) {
            header = this.keycloakService.getHttpHeader2();
        }
        console.log(req, header);
        const authReq = req.clone({ headers: header });

        return next.handle(authReq).pipe(
            catchError((error: HttpErrorResponse) => {
                console.log(error);
                let message = '';
                if (error) {
                    switch (error.status) {
                        case 400:
                            message = error?.error;
                            break;
                        case 401:
                            this.keycloakService.goToLogin();
                            message = this.translateService.instant(
                                'IHRE_SITZUNG_IST_ABGELAUFEN',
                            );
                            break;
                        case 404:
                            message =
                                this.translateService.instant('NOT_FOUND');
                            break;
                        case 499:
                            message = this.translateService.instant(
                                'BROWSER_CLOSED_CONNECTION',
                            );
                            break;
                        case 500:
                            message = this.translateService.instant(
                                'SERVER_NICHT_ERREICHBAR',
                            );
                            break;
                        default:
                            break;
                    }
                }
                this.loader.hideLoader();
                this.loader.openSnackBar(message, 'error');
                throw error;
            }),
            finalize(() => this.loader.hideLoader()),
        );
    }
}
